import { CartAddEvent } from '@theme/events';

const root=window.Shopify?.routes?.root || '/';
const url=path=>`${root}${path}`.replace(/\/\//g,'/');
const paintIds=new Set([6643314884791,6925833109687,6925833666743,6925834879159]);
const includedPaint=item=>(item.options_with_values || []).some(option=>
  (option.name==='Skate Paint Protection' && option.value==='Yes') ||
  (option.name==='With Skate Paint' && option.value!=='None')
);
const fetchJson=async(path)=>{const response=await fetch(url(path),{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Recommendations unavailable');return response.json()};
const make=(tag,value,className)=>{const node=document.createElement(tag);if(value!==undefined)node.textContent=value;if(className)node.className=className;return node};
const money=amount=>new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(amount);
const rendered=new WeakSet();
let loading=false;
let adding=false;

async function render(){
  if(loading)return;
  const hosts=[...document.querySelectorAll('[data-native-cart-recommendations]')].filter(host=>!rendered.has(host));
  if(!hosts.length)return;
  loading=true;
  for(const host of hosts)rendered.add(host);
  try{
    const cart=await fetchJson('cart.js');
    if(!cart.items.length){for(const host of hosts)host.replaceChildren();return;}
    const inCart=new Set(cart.items.map(item=>Number(item.product_id)));
    const paintCovered=cart.items.some(includedPaint);
    const eligible=product=>{
      const id=Number(product.id);
      return !inCart.has(id)&&!(paintCovered&&paintIds.has(id))&&product.available!==false&&product.variants?.some(variant=>variant.available);
    };
    const ids=[...inCart];
    const requests=await Promise.allSettled(ids.map(id=>fetchJson(`recommendations/products.json?product_id=${id}&limit=10&intent=complementary`)));
    const choices=[];
    const seen=new Set();
    // recommendations/products.json prices are cents; collections/products.json
    // prices are decimal currency strings. Keep the source alongside each item.
    const collect=(products,priceUnit)=>{for(const product of products || []){const id=Number(product.id);if(seen.has(id)||!eligible(product))continue;seen.add(id);choices.push({product,priceUnit});if(choices.length===3)break;}};
    for(const result of requests){if(result.status==='fulfilled')collect(result.value.products,'cents');if(choices.length===3)break;}
    // Complements have priority. An available catalog fallback fills sparse mappings,
    // including gift cards, while excluding items already in the cart.
    if(choices.length<3){
      try{const catalog=await fetchJson('collections/all/products.json?limit=100');collect(catalog.products,'decimal');}catch{}
    }
    for(const host of hosts){
      host.replaceChildren();
      if(!choices.length)continue;
      host.append(make('h3','More ways to skate','native-cart-recommendations__title'));
      for(const {product,priceUnit} of choices){
        const card=make('article',undefined,'native-cart-recommendations__card');
        const link=make('a',undefined,'native-cart-recommendations__link');
        link.href=url(`products/${encodeURIComponent(product.handle)}`);
        if(product.featured_image){const image=document.createElement('img');image.src=product.featured_image;image.alt='';image.loading='lazy';link.append(image);}
        const info=make('span',undefined,'native-cart-recommendations__info');
        info.append(make('strong',product.title));
        const available=product.variants.filter(variant=>variant.available);
        const from=available.length>1||product.variants.length>1;
        const lowest=Math.min(...available.map(variant=>Number(variant.price)));
        info.append(make('span',`${from?'From ':''}${money(priceUnit==='cents'?lowest/100:lowest)}`,'native-cart-recommendations__price'));
        link.append(info);card.append(link);
        if(available.length===1&&product.variants.length===1){
          const button=make('button','Add','button button--secondary');button.type='button';
          button.addEventListener('click',async()=>{
            if(adding)return;
            adding=true;button.disabled=true;button.textContent='Adding…';
            try{
              const components=[...document.querySelectorAll('cart-items-component[data-section-id]')];
              const sections=[...new Set(components.map(component=>component.dataset.sectionId))];
              const response=await fetch(url('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:available[0].id,quantity:1,sections,sections_url:location.pathname})});
              const added=await response.json();
              if(!response.ok||added.status||sections.some(id=>!added.sections?.[id]))throw Error(added.description || 'Could not refresh cart');
              host.dispatchEvent(new CartAddEvent(added,String(available[0].id),{source:'native-cart-recommendations',itemCount:1,productId:String(product.id),sections:added.sections}));
              document.querySelector('cart-drawer-component')?.open();
            }catch(error){button.textContent='Try again';button.setAttribute('aria-label',`Could not add ${product.title}. Try again.`);}
            finally{adding=false;button.disabled=false;}
          });
          card.append(button);
        }else{
          const action=make('a','Choose options','button button--secondary');action.href=link.href;card.append(action);
        }
        host.append(card);
      }
    }
  }catch{for(const host of hosts)host.replaceChildren();}
  finally{loading=false;if([...document.querySelectorAll('[data-native-cart-recommendations]')].some(host=>!rendered.has(host)))queueMicrotask(render);}
}

render();
new MutationObserver(()=>{if([...document.querySelectorAll('[data-native-cart-recommendations]')].some(host=>!rendered.has(host)))render();}).observe(document.documentElement,{subtree:true,childList:true});
document.addEventListener('cart:update',()=>{
  for(const host of document.querySelectorAll('[data-native-cart-recommendations]'))rendered.delete(host);
  queueMicrotask(render);
});
